module.exports = __webpack_public_path__ + "media/images/admin/icons/pocket-b99de34a551a968511398dc4d8ee3b52.svg";